import React, { Component } from "react";

import styles from "./styles";

class Avatar extends Component {
  format(word) {
    let firstLetter, secondLetter, letters;

    if (word) {
      const hasWhitespace = word.indexOf(" ") >= 0;

      if (hasWhitespace) {
        word = word.split(" ");
        firstLetter = word[0].toUpperCase().substring(0, 1);
        secondLetter = word[1].toUpperCase().substring(0, 1);
        letters = [firstLetter, secondLetter];
      } else {
        firstLetter = word.toUpperCase().substring(0, 1);
        secondLetter = word.toUpperCase().substring(1, 2);
        letters = [firstLetter, secondLetter];
      }
    }
    return letters && letters.length > 0 ? letters.join("") : "";
  }

  render() {
    const { className } = this.props;

    return (
      <div className={className}>
        <div className="company__avatar" style={this.props.style}>
          {this.format(this.props.name)}
        </div>
      </div>
    );
  }
}

export default styles(Avatar);



// WEBPACK FOOTER //
// ./src/components/support/avatar/index.jsx